import { ProfilesClient } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useMutation } from "@tanstack/react-query";

const profileClient = new ProfilesClient(undefined, axios);

export interface ExportProfileRequest {
  profileId: string;
}

export const useExportProfile = (options?: {
  onSuccess?: (data: Blob, variables: ExportProfileRequest) => void | Promise<void>;
  onError?: (error: Error) => void;
}) => {
  return useMutation<Blob, Error, ExportProfileRequest>({
    mutationFn: async ({ profileId }: ExportProfileRequest) => {
      const response = await profileClient.exportProfile(profileId);
      return response.data;
    },
    onSuccess: async (data: Blob, variables: ExportProfileRequest) => {
      options?.onSuccess?.(data, variables);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};

/**
 * Utility function to download a blob as a file
 */
export const downloadBlobAsFile = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

